import React from 'react';

function Hireink() {
    return (
        <>

            <div className='col col-xl-8 offset-xl-1 offset-xxl-2'> 
                
            </div>


        </> 
    );
}

export default Hireink;